// extracted by mini-css-extract-plugin
module.exports = {"cartCountContainer":"OutletMenuProductCard_cartCountContainer__nxp1H","imageOnTopStyle":"OutletMenuProductCard_imageOnTopStyle__irMI0"};